<template>
    <base-side-bar>
        <div class="flex flex-col items-center justify-center w-full mx-10">
            <h2
                class="font-extrabold leading-9 text-center text-blue-600 sm:text-xl sm:leading-10"
            >
                Programme d'investissement et plan de financement
            </h2>
            <br />
            <wide-card title="ITMO" titleClass="text-center mb-2">
                <multiselect
                    v-model="programmeDinvestissementPlanDeFinancement.ITMO"
                    :options="ITMOOptions"
                    :multiple="true"
                    placeholder="ITMO"
                    track-by="name"
                    label="name"
                >
                    <span slot="noResult">Oops! aucun résultat trouvé.</span>
                </multiselect>
                <base-number-input
                    v-for="(input,
                    index) in programmeDinvestissementPlanDeFinancement.ITMO"
                    :key="input.code"
                    :label="input.name + ' :'"
                    placeholder="montant"
                    v-model="input.value"
                    :isCurrency="true"
                    :hasError="
                        $v.programmeDinvestissementPlanDeFinancement.ITMO[
                            `${index}`
                        ].$error
                    "
                    :errorMessage="
                        errorMessage(
                            input.name,
                            $v.programmeDinvestissementPlanDeFinancement.ITMO[
                                `${index}`
                            ].value
                        )
                    "
                    @blur="
                        $v.programmeDinvestissementPlanDeFinancement.ITMO[
                            `${index}`
                        ].value.$touch()
                    "
                />
                <h2
                    class="mt-6 text-sm font-extrabold leading-9 text-left text-blue-600 sm:text-lg sm:leading-10"
                >
                    Total
                </h2>
                <div class="flex items-center bg-gray-300">
                    <h2 class="p-2 text-lg font-extrabold leading-9">
                        {{ formatPrice(nonValueAssetTotal) }}
                    </h2>
                </div>
            </wide-card>

            <wide-card
                title="Plan de financement"
                titleClass="text-center mb-4"
            >
                <div class="grid items-center grid-cols-2 gap-4">
                    <h3 class="text-lg text-blue-600">Capital social</h3>
                    <base-number-input
                        placeholder="montant"
                        v-model="
                            programmeDinvestissementPlanDeFinancement.capitalSocial
                        "
                        :hasError="
                            $v.programmeDinvestissementPlanDeFinancement
                                .capitalSocial.$error
                        "
                        :errorMessage="
                            errorMessage(
                                'Capital social',
                                $v.programmeDinvestissementPlanDeFinancement
                                    .capitalSocial
                            )
                        "
                        @blur="
                            $v.programmeDinvestissementPlanDeFinancement.capitalSocial.$touch()
                        "
                        :isCurrency="true"
                    />
                    <h3 class="text-lg text-blue-600">
                        Apport en comptes courants associés
                    </h3>
                    <base-number-input
                        placeholder="montant"
                        v-model="
                            programmeDinvestissementPlanDeFinancement.compteAssocie
                        "
                        :hasError="
                            $v.programmeDinvestissementPlanDeFinancement
                                .compteAssocie.$error
                        "
                        :errorMessage="
                            errorMessage(
                                'Apport en comptes courants associés',
                                $v.programmeDinvestissementPlanDeFinancement
                                    .compteAssocie
                            )
                        "
                        :isCurrency="true"
                        @blur="
                            $v.programmeDinvestissementPlanDeFinancement.compteAssocie.$touch()
                        "
                    />
                    <template v-for="index in 2">
                        <h3 class="text-lg text-blue-600" :key="index">
                            Crédit bancaire (montant / durée par mois / taux)
                        </h3>
                        <div class="flex" :key="index">
                            <base-number-input
                                placeholder="montant"
                                v-model="
                                    programmeDinvestissementPlanDeFinancement
                                        .creditBancaire[`${index - 1}`].montant
                                "
                                :isCurrency="true"
                                :hasError="
                                    $v.programmeDinvestissementPlanDeFinancement
                                        .creditBancaire[`${index - 1}`].montant
                                        .$error
                                "
                                :errorMessage="
                                    errorMessage(
                                        'Crédit bancaire',
                                        $v
                                            .programmeDinvestissementPlanDeFinancement
                                            .creditBancaire[`${index - 1}`]
                                            .montant
                                    )
                                "
                                @blur="
                                    $v.programmeDinvestissementPlanDeFinancement.creditBancaire[
                                        index
                                    ].montant.$touch()
                                "
                            />
                            <base-number-input
                                placeholder="Durée"
                                v-model="
                                    programmeDinvestissementPlanDeFinancement
                                        .creditBancaire[index - 1].duree
                                "
                                :hasError="
                                    $v.programmeDinvestissementPlanDeFinancement
                                        .creditBancaire[`${index - 1}`].duree
                                        .$error
                                "
                                :errorMessage="
                                    errorMessage(
                                        'Crédit bancaire',
                                        $v
                                            .programmeDinvestissementPlanDeFinancement
                                            .creditBancaire[`${index - 1}`]
                                            .duree
                                    )
                                "
                                @blur="
                                    $v.programmeDinvestissementPlanDeFinancement.creditBancaire[
                                        index
                                    ].duree.$touch()
                                "
                            />
                            <base-number-input
                                placeholder="Taux"
                                v-model="
                                    programmeDinvestissementPlanDeFinancement
                                        .creditBancaire[index - 1].taux
                                "
                                :hasError="
                                    $v.programmeDinvestissementPlanDeFinancement
                                        .creditBancaire[`${index - 1}`].taux
                                        .$error
                                "
                                :errorMessage="
                                    errorMessage(
                                        'Crédit bancaire',
                                        $v
                                            .programmeDinvestissementPlanDeFinancement
                                            .creditBancaire[`${index - 1}`].taux
                                    )
                                "
                                @blur="
                                    $v.programmeDinvestissementPlanDeFinancement.creditBancaire[
                                        index
                                    ].taux.$touch()
                                "
                            />
                        </div>
                    </template>
                </div>
                <h2
                    class="text-xl font-extrabold leading-9 text-center text-blue-600 sm:text-xl sm:leading-10"
                >
                    Total Plan Financement (HT)
                </h2>

                <div class="flex items-center bg-gray-300">
                    <h2 class="p-2 text-lg font-extrabold leading-9">
                        {{ formatPrice(capitalSocialTotal) }}
                    </h2>
                </div>
            </wide-card>

            <base-primary-button title="Suivant" @click="addPlanFinancement" />
        </div>
    </base-side-bar>
</template>

<script>
import WideCard from "../../../components/cards/wideCard";
import { mapState } from "vuex";
import {
    decimal,
    minValue,
    requiredIf,
    required
} from "vuelidate/lib/validators";
import { errorMessage } from "@/mixins/errorMessage.js";
import { formatPriceMixin } from "@/mixins/helpersMixin.js";
import { scrollToError } from "@/mixins/scrollToMixin.js";

export default {
    components: { WideCard },

    mixins: [errorMessage, formatPriceMixin, scrollToError],

    validations() {
        let formValidation = {
            capitalSocial: { required, decimal, minValue: minValue(0) },
            compteAssocie: { decimal, minValue: minValue(0) }
        };
        let ITMOValidation = {};
        if (this.programmeDinvestissementPlanDeFinancement.ITMO.length !== 0) {
            let repeaterRules = this.programmeDinvestissementPlanDeFinancement.ITMO.map(
                (input, index) => {
                    return {
                        [`${index}`]: {
                            value: {
                                required,
                                minValue: minValue(1)
                            }
                        }
                    };
                }
            );

            ITMOValidation = {
                ...Object.assign({}, ...repeaterRules)
            };
        }

        let creditBancaireValidation = {};

        if (
            this.programmeDinvestissementPlanDeFinancement.creditBancaire
                .length !== 0
        ) {
            let creditBancaireRepeater = this.programmeDinvestissementPlanDeFinancement.creditBancaire.map(
                (input, index) => {
                    const check = () => {
                        if (
                            this.programmeDinvestissementPlanDeFinancement
                                .creditBancaire[index].montant === null ||
                            this.programmeDinvestissementPlanDeFinancement
                                .creditBancaire[index].montant === 0
                        )
                            return false;
                        return true;
                    };
                    return {
                        [`${index}`]: {
                            montant: { decimal, minValue: minValue(0) },
                            duree: {
                                decimal,
                                minValue: check() ? minValue(1) : minValue(0),
                                required: requiredIf(check)
                            },
                            taux: {
                                decimal,
                                minValue: minValue(0),
                                required: requiredIf(check)
                            }
                        }
                    };
                }
            );

            creditBancaireValidation = {
                ...Object.assign({}, ...creditBancaireRepeater)
            };
        }
        formValidation = {
            ...formValidation,
            ITMO: ITMOValidation,
            creditBancaire: creditBancaireValidation
        };
        return {
            programmeDinvestissementPlanDeFinancement: formValidation
        };
    },
    data() {
        return {
            programmeDinvestissementPlanDeFinancement: {}
        };
    },
    created() {
        this.programmeDinvestissementPlanDeFinancement = this.$store.getters[
            "EtudeFinanciere/getInvestmentProgramme"
        ];
        this.$store.dispatch("forms/showSection", "Étude Financiere");
        this.$store.dispatch(
            "forms/stepFocus",
            "Programme d’investissement plan de financement"
        );
    },
    methods: {
        addPlanFinancement() {
            this.$v.$touch();
            if (!this.$v.$invalid) {
                if (this.capitalSocialTotal === this.nonValueAssetTotal) {
                    this.$store.dispatch("EtudeFinanciere/addPlanFinancement", {
                        ...this.programmeDinvestissementPlanDeFinancement,
                        nonValueAssetTotal: this.nonValueAssetTotal
                    });
                    this.$store.dispatch(
                        "EtudeFinanciere/SaveInvestorsProgramme"
                    );
                    this.$store.dispatch(
                        "forms/subStepComplete",
                        "Programme d’investissement plan de financement"
                    );

                    this.$router.push({
                        name: "chiffres_daffaires_previsionnels",
                        params: { uid: `${this.$store.state.user.bpiId}` }
                    });
                } else {
                    this.$emit("showNotification", {
                        error: true,
                        content:
                            "Votre plan d'investissement doit être égal au plan financement. Merci de bien vouloir vérifier à nouveau vos informations.",
                        title: "Attention"
                    });
                }
            } else {
                this.scrollToError();

                this.$emit("showNotification", {
                    error: true,
                    content:
                        "Une erreur a été détectée, veuillez revérifier les informations remplies.",
                    title: "Attention"
                });
            }
        }
    },
    computed: {
        ...mapState("forms", {
            ITMOOptions: state =>
                state.ProgrammeDinvestissementPlanDeFinancement.ITMOOptions
        }),

        nonValueAssetTotal() {
            if (this.programmeDinvestissementPlanDeFinancement === undefined)
                return 0;
            if (
                this.programmeDinvestissementPlanDeFinancement.ITMO.length === 1
            )
                return this.programmeDinvestissementPlanDeFinancement.ITMO[0]
                    .value;
            return this.programmeDinvestissementPlanDeFinancement.ITMO.reduce(
                (a, b) => a + parseInt(b.value),
                0
            );
        },
        capitalSocialTotal() {
            const investorObject = this
                .programmeDinvestissementPlanDeFinancement;
            let total = 0;
            total += investorObject?.capitalSocial ?? 0;
            total += investorObject?.compteAssocie ?? 0;
            total += investorObject.creditBancaire.reduce(
                (sum, creditBancaire) => {
                    return (creditBancaire?.montant ?? 0) + sum;
                },
                0
            );
            return total;
        }
    }
};
</script>

<style></style>
